import { v4 } from 'uuid';

export const TEST_USER_EMAIL_REGEX = /^test-user\+.*@([a-z0-9-]+\.)?ecologi\.com$/;
export const TEST_ADMIN_USER_EMAIL_REGEX = /^test-user\+admin-.*@([a-z0-9-]+\.)?ecologi\.com$/;
export const TEST_ZERO_USER_EMAIL_REGEX = /^e2e-auto-.*@ecologi\.com$/;

export const isTestUserEmail = (email: string | undefined | null): boolean => {
  if (!email) return false;
  return TEST_USER_EMAIL_REGEX.test(email.toLowerCase());
};

export const isTestAdminUserEmail = (email: string): boolean => {
  return TEST_ADMIN_USER_EMAIL_REGEX.test(email.toLowerCase());
};

export const generateRandomTestUserEmail = (subdomain?: string) => {
  const domain = subdomain ? `${subdomain}.ecologi.com` : 'ecologi.com';
  return `test-user+${v4()}@${domain}`;
};

export const generateRandomTestAdminUserEmail = (subdomain?: string) => {
  const domain = subdomain ? `${subdomain}.ecologi.com` : 'ecologi.com';
  return `test-user+admin-${v4()}@${domain}`;
};

export const SESSION_COOKIE_ABSOLOUTE_LIFETIME = 60 * 60 * 24 * 7;
export const SESSION_COOKIE_INACTIVITY_LIFETIME = 60 * 60 * 24 * 3;
export const DEFAULT_AUTH_SCOPES = 'openid profile email offline_access';

export * from './test-auth';
